import { render, staticRenderFns } from "./player-transactions.vue?vue&type=template&id=066b33f1&"
import script from "./player-transactions.vue?vue&type=script&lang=js&"
export * from "./player-transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports